import type { RosieResource } from './permissions.types';

function pathCovers(
  pathPrefix: string,
  base: string,
  opts?: { excludeLegacySeals?: boolean },
): boolean {
  if (pathPrefix === base || pathPrefix.startsWith(`${base}/`)) {
    if (
      opts?.excludeLegacySeals &&
      pathPrefix.startsWith('/seals/legacy')
    ) {
      return false;
    }
    return true;
  }
  return false;
}

const COARSE_PREFIX: Record<RosieResource, string | null> = {
  txters: '/my-txt',
  'my-txt': '/my-txt',
  scla: '/scla',
  hackathon: '/hackathon',
  seals: '/seals',
  'seals-legacy': '/seals/legacy',
  labs: '/labs',
  'automated-calls': '/automated-calls',
  'batch-sms': '/batch-sms',
  equipment: '/technology',
  'txt-merch': '/txt-merch',
  'txt-programs': '/txt-programs',
  'signed-forms': '/signed-forms',
  activities: '/txt-learning',
  surveys: '/surveys',
  emails: '/emails',
  'rosie-users': '/admin',
  'rosie-roles': '/admin/manage-roles',
  bitwarden: '/admin/bitwarden',
  'dropbox-audit': '/admin/dropbox/audit',
  bagel: '/bagel',
  // No legacy coarse permission ever existed for this resource — grants are
  // via granular `programs-scla-mobile-applications:read`/`:write` only.
  // Keep the RosieResource key for any early `mothership:*` coarse strings.
  mothership: null,
};

/** Whether a route rule path falls under a coarse RosieResource for write checks. */
export default function coarseResourceMatchesRulePath(
  resource: RosieResource,
  pathPrefix: string,
): boolean {
  if (resource === 'seals') {
    return pathCovers(pathPrefix, '/seals', { excludeLegacySeals: true });
  }
  if (resource === 'seals-legacy') {
    return pathCovers(pathPrefix, '/seals/legacy');
  }
  if (resource === 'rosie-users') {
    return (
      pathPrefix.startsWith('/admin') &&
      !pathPrefix.startsWith('/admin/bitwarden') &&
      !pathPrefix.startsWith('/admin/dropbox')
    );
  }
  if (resource === 'bitwarden') {
    return pathPrefix.startsWith('/admin/bitwarden');
  }
  if (resource === 'dropbox-audit') {
    return pathPrefix.startsWith('/admin/dropbox/audit');
  }
  if (resource === 'emails') {
    return pathPrefix.startsWith('/emails');
  }
  const base = COARSE_PREFIX[resource];
  if (!base) return false;
  return pathCovers(pathPrefix, base);
}
